import React, { Component } from "react"
import FormField from "../FormField"
import { InputNumber } from "formik-antd"

export default class AvgHearts extends Component {
  render() {
    return (
      <FormField name={this.props.name || "metadata.avg_hearts"} label="Avg. Hearts">
        <InputNumber
          data-cy="account-avg-hearts"
          style={{ width: "100%" }}
          size="large"
          placeholder="1000"
        />
      </FormField>
    )
  }
}
